import { OrderDefinitions } from 'models/Order';

export const orderDefinition: OrderDefinitions = {
  orderInfo: [
    {
      type: 'text',
      fieldName: 'orderNumber',
      label: 'orders.ORDER_ID',
    },
    {
      type: 'date',
      fieldName: 'createdDate',
      label: 'orders.ORDER_DATE',
      placeholder: 'orders.ORDER_DATE',
    },
  ],
  customerInfoFirst: [
    {
      type: 'text',
      fieldName: 'customerContact',
      label: 'orders.FIELDLABEL_CREATED_BY',
      placeholder: 'orders.FIELD_PLACEHOLDER_CREATED_BY',
      rules: { required: true },
    },
    {
      type: 'text',
      fieldName: 'customerContactPhone',
      label: 'orders.FIELDLABEL_ORDER_PHONE',
      placeholder: 'orders.FIELD_PLACEHOLDER_ORDER_PHONE',
      description: 'orders.FIELD_DESCRIPTION_ORDER_PHONE',
      rules: {
        required: true,
        pattern: {
          value: /^\+?(\d{1,3})?[-\s]?(\d{1,4})[-\s]?(\d{2,3})[-\s]?(\d{2,3})[-\s]?(\d{0,3})$/,
          message: 'Invalid phone number format',
        },
      },
    },
  ],
  employeeInfo: [
    {
      type: 'text',
      fieldName: 'requestedName',
      label: 'orders.FIELDLABEL_EMPLOYEE_NAME',
      placeholder: 'orders.FIELD_PLACEHOLDER_EMPLOYEE_NAME',
      description: 'orders.FIELD_DESCRIPTION_EMPLOYEE_NAME',
      rules: { required: true },
    },
    {
      type: 'text',
      fieldName: 'requestedPersonalNumber',
      label: 'orders.FIELDLABEL_EMPLOYEE_PERSONAL_IDENTITY_NUMBER',
      placeholder: 'orders.FIELD_PLACEHOLDER_EMPLOYEE_PERSONAL_IDENTITY_NUMBER',
      description: 'orders.FIELD_DESCRIPTION_EMPLOYEE_PERSONAL_IDENTITY_NUMBER',
      rules: {
        required: true,
        pattern: {
          value: /^\d{6}-\d{4}$/,
          message: '',
        },
      },
    },
    {
      type: 'text',
      fieldName: 'requestedPhone',
      label: 'orders.FIELDLABEL_EMPLOYEE_MOBILE_PHONE',
      placeholder: 'orders.FIELD_PLACEHOLDER_EMPLOYEE_MOBILE_PHONE',
      description: 'orders.FIELD_DESCRIPTION_EMPLOYEE_MOBILE_PHONE',
      rules: {
        required: true,
        pattern: {
          value: /^\+?(\d{1,3})?[-\s]?(\d{1,4})[-\s]?(\d{2,3})[-\s]?(\d{2,3})[-\s]?(\d{0,3})$/,
          message: 'Invalid phone number format',
        },
      },
    },
    {
      type: 'text',
      fieldName: 'requestedEmail',
      label: 'orders.FIELDLABEL_EMPLOYEE_EMAIL',
      placeholder: 'orders.FIELD_PLACEHOLDER_EMPLOYEE_EMAIL',
      rules: {
        required: false,
        pattern: {
          value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          message: '',
        },
      },
    },
    {
      type: 'textArea',
      fieldName: 'requestedHomeAddress',
      label: 'orders.FIELDLABEL_EMPLOYEE_ADDRESS',
      placeholder: 'orders.FIELD_PLACEHOLDER_EMPLOYEE_ADDRESS',
      rules: {
        required: false,
        pattern: {
          value: /^[\s\S]{0,300}$/,
          message: 'Max 300 characters allowed',
        },
      },
    },
    {
      type: 'checkbox',
      fieldName: 'smsConsent',
      label: 'orders.FIELD_LABEL_EMPLOYEE_SMS_CONSENT',
      placeholder: 'orders.FIELD_PLACEHOLDER_EMPLOYEE_SMS_CONSENT',
    },
  ],
  groupInfo: [
    {
      type: 'number',
      fieldName: 'requestedNumberOfAttendees',
      label: 'orders.FIELDLABEL_GROUP_SIZE',
      placeholder: 'orders.FIELD_PLACEHOLDER_GROUP_SIZE',
      description: 'orders.FIELD_DESCRIPTION_GROUP_SIZE',
      rules: { required: true, min: 4, max: 9999 },
    },
    {
      type: 'checkbox',
      fieldName: 'smsConsent',
      label: 'orders.FIELD_LABEL_GROUP_SMS_CONSENT',
      placeholder: 'orders.FIELD_PLACEHOLDER_GROUP_SMS_CONSENT',
      description: 'orders.FIELD_DESCRIPTION_GROUP_SMS_CONSENT',
    },
  ],
  educationInfo: [
    {
      type: 'number',
      fieldName: 'requestedNumberOfAttendees',
      label: 'orders.FIELDLABEL_GROUP_SIZE',
      placeholder: 'orders.FIELD_PLACEHOLDER_GROUP_SIZE',
      description: 'orders.FIELD_DESCRIPTION_EDUCATION_GROUP_SIZE',
      rules: { required: true, min: 1, max: 9999 },
    },
  ],
  descriptionInfo: [
    {
      type: 'textArea',
      fieldName: 'requestedBriefDesc',
      label: 'orders.FIELDLABEL_REQUESTED_SERVICE_DESCRIPTION',
      placeholder: 'orders.FIELD_PLACEHOLDER_REQUESTED_SERVICE_DESCRIPTION',
      rules: { required: true },
      class: 'col-md-12 mt-4',
    },
  ],
};
